<template>
  <div>
    <div class="section_rel">
      <div class="ex_section">
        <div class="ex_section_wrap">
          <div class="basic_info boxshadow1" style="min-height:115px" >
            <div class="mini_box">
              <div class="caption">商品编码</div>
            <table >
              <tbody>
                <tr v-for="(item,index) in crumbs">
                <th colspan="1" class="label " style="color: #666;
                font-weight: 700;
                font-size: 14px;">{{item.code}}</th>
                <td colspan="1" style="color: #666;
                font-size: 15px;" >  {{item.name}}</td></tr>
              
              </tbody>
        
        
        
        
        
        </table>
      </div>
         
          </div>
          <div class="basic_info boxshadow1" style="min-height:250px">
         
            <div class="mini_box">
              <div class="caption">需要的贸易清单</div>
              <div class="cell">
                <div style="color: #666;
                font-weight: 700;
                font-size: 14px;">监管条件（证件）代码</div>
                  <!-- <Col span="24" class="title">{{$t('query.result.hscode.trade.code')}}</Col> -->
                  
                    <Regulator types="regulatorCode" :codes="dataSet.regulatorCode"></Regulator>
                    <div style="color: #666;
                    font-weight: 700;
                    font-size: 14px;margin-top:10px">检验检疫（证件）代码</div>
                  <!-- <Col span="24" class="title">{{$t('query.result.hscode.trade.category')}}</Col> -->
               
                    <Regulator types="quarantineInspectionType" :codes="dataSet.quarantineInspectionType"></Regulator>
         
                 
            
              </div>
            </div>
          </div>
        
        </div>
      </div>
      <div class="right_box">
        <div class="right_box_wrap boxshadow1">
          <div class="caption">
            {{$t('query.result.hscode.tax.title')}}
            <a class="more" href="#" @click.stop.prevent="jfNotice($event, {name: 'queryRateI', params: {exporter: rankdomExporter.exporter.id, importer: importerData.id, hscode: hscode},query: {
                    text: rankdomExporter.exporter.name
                  }
})" v-if="ranks && ranks.length > 0 && !_.isEmpty(importerData)">
              查看该商品的FTA<svg-icon icon-class="arrow2"></svg-icon>
            </a>
          </div>
      <div class="cell">
        <Row :gutter="5" class="row-caption">
          <Col span="7" class="title-caption">自定义税率</Col>
          <Col span="5" class="value">&nbsp;</Col>
          <Col span="7" class="title-caption">其他税率</Col>
          <Col span="5" class="value"></Col>
        </Row>
        <Row :gutter="5">
          <Col span="7" class="title">一般税率</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueAccording(dataSet.importTax, dataSet.importTaxDescription)"></RateView>
          </Col>
          <Col span="7" class="title">增值税税率</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.taxAddedValue)"></RateView>
          </Col>
          <Col span="7" class="title">最惠国关税税率</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueAccording(dataSet.importMfnTax, dataSet.importMfnTaxDescription)"></RateView>
          </Col>
          <Col span="7" class="title">消费税税率</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.taxExcise)"></RateView>
          </Col>
          <Col span="7" class="title">{{$t('query.result.rate.compare.ifr')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueAccording(dataSet.importTaxProvisional, dataSet.importTaxProvisionalDescription)"></RateView>
          </Col>
          <Col span="7" class="title">{{$t('query.result.hscode.tax.adtrate')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.taxAntiDumping)"></RateView>
          </Col>
          <Col span="7" class="title">{{$t('query.result.rate.related.astr')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.taxAntiSubsidy)"></RateView>
          </Col>
        </Row>
      </div>
      <div class="caption">{{$t('query.result.hscode.related.title')}}</div>
      <div class="cell">
        <Row :gutter="5">
          <Col span="7" class="title">{{$t('query.result.hscode.related.er')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.exportTax)"></RateView>
          </Col>
          <Col span="7" class="title">{{$t('query.result.hscode.related.err')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.exportDrawbackTax)"></RateView>
          </Col>
          <Col span="7" class="title">{{$t('query.result.hscode.related.epr')}}</Col>
          <Col span="5" class="value">
            <RateView :content="$options.filters.rateValueConver(dataSet.exportTaxProvisional)"></RateView>
          </Col>
        </Row>
      </div>
        </div>
      </div>
    </div>
    <div class="basic_info boxshadow1" >
         
      <div class="mini_box">
        <div class="caption">CIQ</div>
        <div class="cell">
          <Row :gutter="5">
            <Col span="12" class="title">CIQ编码：{{ ciq.he }}</Col>
            
            <Col span="12" class="title">CIQ名称：{{ ciq.heNameCN }}</Col>
        
            <Col span="12" class="title">附加码：{{ ciq.extendHs }}</Col>
           
            <Col span="12" class="title">类型：{{ ciq.extendCN }}</Col>
           
           
          </Row>
   
           
      
        </div>
      </div>
    </div>
    <div class="basic_info boxshadow1" >
         
      <div class="mini_box">
        <div class="caption">申报要素</div>
        <div class="cell">
          <Row :gutter="5">
            {{ modelField.element }}
           
          </Row>
   
           
      
        </div>
      </div>
    </div>
    <!-- <HsCodeFooter></HsCodeFooter> -->
    <Modal v-model="isShowCodeModal" class="rglCodeModalBox" class-name="vertical-center-modal">
      <span slot="header"></span>
      <div class="modal-content">
        <div class="modal-content-wrap">
          <div class="title">监管证件代码/检验检疫类别</div>
          <div class="modal_content" :style="{height: `${modalContentHeight}px`}">
            <iscroll-view class="scroll-view" :options="{disableTouch: true, momentum: false, mouseWheel: true, scrollbars: true, fadeScrollbars: true, interactiveScrollbars: true, snap: false}" ref="iscroll">
              <div><Regulator :types="types" :codes="codes"></Regulator></div>
            </iscroll-view>
          </div>
        </div>
      </div>
      <div slot="footer"></div>
    </Modal>
    <Statement></Statement>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import RateView from '@/components/query/common/RateView'
const { mapState: mapDataState, mapGetters: mapDataGetters } = createNamespacedHelpers('data')
import HsCodeFooter from './HsCodeFooter'
import Statement from "@/components/layout/statement";
import Regulator from "@/components/query/common/regulator2";
export default {
  name: 'HsCodeContent',
  components: { RateView, HsCodeFooter,Statement,Regulator },
  props: {
    crumbs: {
      type: Array,
      default: () => []
    },
    dataSet: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    ciq: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    modelField: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    importArea: {
      type: Object,
      default: () => { return {} },
      required: false
    },
    ranks: {
      type: Array,
      default: () => [],
      required: false
    },
    hscode: {
      type: [String, Number]
    }
  },
  data () {
    return {
      isShowCodeModal: false,
      codes:"",
      types:""
    }
  },
  computed: {
    crumbsData () {
      return this._.reduce(this.crumbs, (res, item) => {
        res.push(`(${this.$options.filters.specialHSCodeValue(item.code)}) ${item.name}`)
        return res
      }, []).join('、')
    },
    modalContentHeight () {
      let h = this._h.getWinHeight() - 260
      return h >= 530 ? 530 : (h < 280 ? 280 : h)
    },
    rankdomExporter () {
      if (this._.isEmpty(this.ranks)) return null
      let index = this._.random(1, this.ranks.length)
      return this.ranks[index - 1]
    },
    importerData () {
      if (!this._.isEmpty(this.importArea)) {
        return this.importArea
      } else if (!this._.isEmpty(this.importerAll)) {
        return this.importerAll[0]
      }
      return null
    },
    apiPrice () {
      if (this._.isEmpty(this.apiValue)) {
        return null
      } else {
        return this.getApiValue()
      }
    },
    ...mapDataState({
      apiValue: state => state.apiValue,
      'importerAll': state => state.importerAll
    })
  },
  watch: {
    isShowCodeModal (newVal, oldVal) {
      if (newVal) {
        setTimeout(() => { this.$refs.iscroll && this.$refs.iscroll.refresh() }, 150)
      }
    }
  },
  methods: {
    clickContent(e, type) {
      this.isShowCodeModal = e;
      this.types = type;
      if (this.types === "regulatorCode") {
        this.codes = this.dataSet.regulatorCode;
      } else {
        this.codes = this.dataSet.quarantineInspectionType;
      }
    },
    jfNotice (event, params) {
      this.GJFNotice(status => {
        if (status) {
          let jf = this.getApiValue()(1)
          if (jf && jf.integral && jf.integral > 0) {
            this.GConfirm(`本次查询将消耗${jf.integral}积点，当天重复查询不再扣除积点。`, status => {
              if (status) {
                this.$router.push(params)
              }
            })
          } else {
            this.$router.push(params)
          }
        } else {
          this.$router.push(params)
        }
      })
    },
    ...mapDataGetters(['getApiValue'])
  }
}
</script>

<style scoped>
table .label{
  background: #fafafa;
  text-align:left
}
table{
  border-collapse: collapse;
    width: 100%;
   
}
th,td{
  border: 1px solid #ebeef5;
    padding: 12px 10px;
}
.ex_section{
  position: relative;
}
.ex_section{
  width: 50%;
}
.ex_section_wrap{
  padding-right: 15px;
}
.basic_info{
  margin-bottom: 30px;
}
.ex_rate{
  padding: 16px 18px;
}
.breadcrumbs{
  font-size: 14px;
  color: #333;
  padding: 14px 18px;
  border-bottom: 1px solid #ccc;
}
.breadcrumbs >>> .ivu-tooltip{
  display: block;
}
.breadcrumbs >>> .ivu-tooltip-rel{
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.breadcrumbs >>> .ivu-tooltip-inner{
  white-space: normal;
}
.right_box{
  position: absolute;
  top: 0;
  right: 0;
  height: 100%;
  width: 50%;
  padding-left: 15px;
}
.section_rel{
  margin-bottom: 30px;
  position: relative;
}
.right_box_wrap{
  height: 100%;
  padding: 16px 18px;
}
  section{
    background-color: #fff;
    padding: 20px 18px;
    box-shadow: 0 2px 4px 0 rgba(223,223,223,0.50);
    margin-bottom: 12px;
  }
  section.mini{
    padding-bottom: 10px;
  }
  section:last-child{
    margin-bottom: 0;
  }
  .mini_box{
    padding: 16px 18px;
  }
  .caption{
    font-size: 16px;
    color: #333;
    background: url("~@/assets/images/home/guide.png") 0 center no-repeat transparent;
    background-size: 12px;
    padding-left: 18px;
    margin-bottom: 15px;
    position: relative;
  }
  .caption .more{
    color: #8892f3;
    font-size: 14px;
    position: absolute;
    font-weight: normal;
    top: 0;
    right: 0;
  }
  .caption .more:hover{
    text-decoration: underline;
  }
  .cell{
    padding: 0 13px;
    font-size: 15px;
  }
  .cell .title{
    color: #666;
    font-size: 15px;
  }
  .cell .value{
    color: #333;
  }
  .basic_info .cell .value >>> .rate-view .ivu-tooltip-rel span{
    color: #8892f3 !important;
  }
  .cell .title-caption{
    color: #666;
    font-weight: bold;
    font-size: 14px;
  }
  .cell >>> .ivu-row{
    margin-bottom: 10px;
  }
  .cell >>> .row-caption,
  .cell >>> .ivu-row:last-child{
    margin-bottom: 0;
  }
  .cell >>> .ivu-col{
    margin-bottom: 20px;
  }
  .cell .value >>> .unit{
    color: #2A2A2A;
    font-size: 12px;
    padding-left: 1px;
  }
  .scroll-view{
    /* -- Attention: This line is extremely important in chrome 55+! -- */
    touch-action: none;
    /* -- Attention-- */
    /*position: fixed;*/
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
  }
  .modal_content{
    overflow: hidden;
    width: 100%;
    position: relative;
  }
</style>
<style>
  .rglCodeModalBox .vertical-center-modal,
  .rglCodeModalBox .ivu-modal{
    width: 640px !important;
    margin: 0 auto;
  }
  .rglCodeModalBox .vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto;
    margin-top: -100px;
  }
  .rglCodeModalBox .vertical-center-modal .ivu-modal{
    top: 0;
  }
  .rglCodeModalBox .ivu-modal-header,
  .rglCodeModalBox .ivu-modal-footer{
    display: none;
  }
  /*.rglCodeModalBox .ivu-modal-close{
    display: none;
  } */
  .rglCodeModalBox .modal-content-wrap .title{
    text-align: center;
    font-size: 15px;
    color: #333;
    margin: 5px 0 12px;
  }
  .rglCodeModalBox .content_image{
    width: 100%;
    display: block;
  }
</style>



// WEBPACK FOOTER //
// src/components/query/zh-CN/HsCodeContent.vue